import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=5db831fe&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style1 from "./setting.vue?vue&type=style&index=1&id=5db831fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db831fe",
  null
  
)

export default component.exports